import { useState, useEffect } from "react";
import API from "../lib/api";

// Fallbacks used only if the API is unreachable
const FALLBACK = {
  skills: [
    "Python","Java","C","C++","JavaScript","TypeScript","React","Node.js",
    "DSA","Machine Learning","Data Science","SQL","MongoDB","AWS","Docker","Git",
    "Flutter","Android Dev","iOS Dev","Blockchain","Cybersecurity",
    "Computer Vision","NLP","Figma","UI/UX Design","Adobe XD","Blender",
    "Unreal Engine","Unity","Graphic Design","After Effects","Premiere Pro",
    "Financial Modeling","Excel","CFA","Accounting","Equity Research",
    "Investment Banking","Python for Finance","Product Management",
    "Business Development","Marketing","SEO","Content Writing","Sales","Operations",
  ],
  branches: [
    "Computer Science","Information Technology","Electronics & Communication",
    "Electrical Engineering","Mechanical Engineering","Civil Engineering",
    "Chemical Engineering","Aerospace Engineering","Biotechnology",
    "Mathematics & Computing","Information Systems","Other",
  ],
  colleges: [
    "BITS Pilani - Pilani Campus",
    "BITS Pilani - Goa Campus",
    "BITS Pilani - Hyderabad Campus",
  ],
  role_types: [
    "Software Engineering","Data Science","Finance","Design",
    "Management","Core Engineering","Research","Other",
  ],
  company_types: [
    "Tech Giants","Indian Startups","MNCs","PSUs",
    "Consulting","Banking/BFSI","Product Companies","Service Companies",
  ],
  locations: [
    "Anywhere in India","Bengaluru","Mumbai","Delhi/NCR",
    "Hyderabad","Pune","Remote Only",
  ],
  graduation_years: [2024,2025,2026,2027,2028],
  pipeline_stages: ["Interested","Interview Scheduled","Offer Received","Rejected"],
  application_statuses: [
    "Pending","Interested","Shortlisted","Interview Scheduled","Offer Received","Rejected",
  ],
  testable_skills: [
    "python","dsa","data structures","data structures & algorithms",
    "algorithms","javascript","js","sql","mysql","postgresql",
  ],
};

let _cache = null;

export function useConfig() {
  const [config, setConfig] = useState(_cache || FALLBACK);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    if (_cache) return;
    API.get("/api/config")
      .then(r => {
        _cache = r.data;
        setConfig(r.data);
      })
      .catch(() => {
        // keep fallback values
      })
      .finally(() => setLoading(false));
  }, []);

  return { config, loading };
}
